import React, { FC } from 'react'
import styled from 'styled-components'
import { CorporateTheme, CreateFormTheme, Theme } from '../../utils/themes'
import StyledText from './StyledText'
import { useTheme } from '../../middleware/ThemeContext'

interface Props {
    icon: React.ReactNode
    buttonTitle: string
    buttonDescription?: string
    onClick?: () => void
}

const StyledCardButton: FC<Props> = ({ icon, buttonTitle, buttonDescription, onClick }) => {
    const { theme } = useTheme();
    return (
        <StyledCard onClick={onClick} theme={theme}>
            <div>
                {icon}
            </div>
            <StyledText fontSize='18px' fontWeight={600}>{buttonTitle}</StyledText>
            <StyledText fontSize='12px' fontWeight={400} textColor={theme.CorporateTheme.colors.textSecondary} className='text-center'>{buttonDescription}</StyledText>

        </StyledCard>
    )
}

const StyledCard = styled.div<{theme:Theme}>`
  border-radius: 10px;
  border: 1px dashed ${CreateFormTheme.colors.inputBorders};
  padding: 40px;
  background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height:207px;
  width: 100%;
  min-width: 250px;
  cursor: pointer;
`

export default StyledCardButton
